import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpModule, JsonpModule } from '@angular/http';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { FormsModule } from '@angular/forms';
//User defined  Take test custom directives
import {
    DefaultThemeDirective, sliderDivDirective, SectionAnchorDirective, QuestionDivDirective, FunCallDirective, FunDivDirective,
    SanitizeHtmlDirective, ChoiceCustomDirective, ConstructFibDirective, ConstructSABDirective,
    ConstructSectionQuesDirective, SectionDetailsDirective, IntializeScrollDirective,
    ConstructLiDirective, ConstructSequenceChoicesDirective, FunCallGuidDirective, FunCallDraggableDirective
    , ConstructFibDndDirective, ConstructImageLablingDirective, ImageLabelingOptionEventsDirective,
    ImageLabelingChoiceEventsDirective, ImageLabelingChoiceanswerEventsDirective, HotspotEventsDirective
    , ReSizeDirective, PassageHtmlDirective, AddQuestionLevelTimeDirective, OnCreate, constructMatchingDNDDirective
} from '../Test/app.taketestdirective';
import { ExamPlayerService } from '../_services/ExamPlayerService';
import { TaketestComponent } from './app.taketest';
import { DeepBlueHeaderComponent } from './Headers/Themes/DeepBlue/app.deepblue';
import { DeepBlueFooterComponent } from './Footers/DeepBlue/app.footer';
import { GreyHeaderComponent } from './Headers/Themes/Grey/app.grey';
import { GreyFooterComponent } from './Footers/Grey/app.footer';
import { SanMarinoHeaderComponent } from './Headers/Themes/SanMarino/app.sanmarino';
import { SanMarinoFooterComponent } from './Footers/SanMarino/app.footer';
import { QuestionCommonComponent } from './QuestionCommon/app.question.common';
import { ButtonsCommonComponent } from './QuestionCommon/app.buttons';
import { HintsCommonComponent } from './QuestionCommon/app.hints';
import { DodgerBlueHeaderComponent } from './Headers/Themes/DodgerBlue/app.dodgerblue';
import { GraphInteractionComponent } from './QuestionTypes/GraphInteraction/GraphInteraction.component';

@NgModule({
    imports: [BrowserModule, FormsModule, HttpModule],
    declarations: [TaketestComponent, GreyHeaderComponent, DeepBlueHeaderComponent, DeepBlueFooterComponent, DodgerBlueHeaderComponent, HintsCommonComponent, sliderDivDirective, QuestionCommonComponent, ButtonsCommonComponent, DefaultThemeDirective, SectionAnchorDirective, QuestionDivDirective, FunCallDirective, FunDivDirective,
        SanitizeHtmlDirective, ChoiceCustomDirective, ConstructFibDirective, ConstructSABDirective,
        ConstructSectionQuesDirective, SectionDetailsDirective, IntializeScrollDirective,
        ConstructLiDirective, ConstructSequenceChoicesDirective, FunCallGuidDirective, FunCallDraggableDirective,
        ConstructFibDndDirective, ConstructImageLablingDirective, ImageLabelingOptionEventsDirective,
        ImageLabelingChoiceEventsDirective, ImageLabelingChoiceanswerEventsDirective, HotspotEventsDirective,
        ReSizeDirective, PassageHtmlDirective, AddQuestionLevelTimeDirective, OnCreate, constructMatchingDNDDirective, SanMarinoHeaderComponent, DeepBlueFooterComponent, GreyFooterComponent, SanMarinoFooterComponent, GraphInteractionComponent],
    exports: [TaketestComponent],
    providers: [ExamPlayerService],
})

export class TakeTestModule {
}



// WEBPACK FOOTER //
// E:/Workspace/TestandAssessment/Manifest/TestPlayer/TestDelivery.TestPlayer/src/app/Test/app.taketest.module.ts